import Radar from 'radar-sdk-js';
import type { RadarAutocompleteResponse } from 'radar-sdk-js/dist/types';

export const radarAutocomplete = async (input: string): Promise<RadarAutocompleteResponse> =>
    Radar.autocomplete({
        query: input,
        limit: 5,
        layers: ['address'],
        countryCode: 'US',
    });
